import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "modal", "background" ]
  static values = { modalShow: Boolean }

  connect() {
  }

  disconnect() {
  }

  showModal(event) {
    event.preventDefault()
    this.modalShowValue = true
  }

  hideModal(event) {
    event.preventDefault()
    this.modalShowValue = false
  }

  modalShowValueChanged() {
    if (this.modalShowValue) {
      this.modalTarget.classList.remove('hidden')
      this.backgroundTarget.classList.remove('hidden')
    } else {
      this.modalTarget.classList.add('hidden')
      this.backgroundTarget.classList.add('hidden')
    }
  }
}
